// extracted by css-extract-rspack-plugin
export default {"Header":"DockedSidebar-module__Header__oE3Mh","HeaderContent":"DockedSidebar-module__HeaderContent__yyCpq","Heading":"DockedSidebar-module__Heading__refiD"};